import React, { forwardRef, useState } from 'react';
import clsx from '@strava/ui/clsx';
import ActionsVisibleDisabledNormalSmall from '@strava/icons/ActionsVisibleDisabledNormalSmall';
import ActionsVisibleNormalSmall from '@strava/icons/ActionsVisibleNormalSmall';
import VisuallyHidden from '../VisuallyHidden';
import Input from '.';

import styles from './PasswordInput.module.scss';

export type PasswordInputProps = React.ComponentPropsWithoutRef<'input'> & {
  showPasswordText: string; // translated text for accessibility. Should inform users that clicking show password button will display the password on the screen
  hidePasswordText: string;
};

const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ showPasswordText, hidePasswordText, className, ...props }, ref) => {
    const [passwordIsVisible, setPasswordIsVisible] = useState(false);

    return (
      <div className={clsx(styles.passwordInput, className)}>
        <Input
          type={passwordIsVisible ? 'text' : 'password'}
          ref={ref}
          {...props}
        />
        <button
          onClick={() => setPasswordIsVisible((prev) => !prev)}
          className={styles.showPasswordButton}
          type="button"
          role="switch"
          aria-checked={passwordIsVisible}
          title={passwordIsVisible ? hidePasswordText : showPasswordText}
        >
          {passwordIsVisible ? (
            <ActionsVisibleNormalSmall />
          ) : (
            <ActionsVisibleDisabledNormalSmall />
          )}
          <VisuallyHidden>
            {passwordIsVisible ? hidePasswordText : showPasswordText}
          </VisuallyHidden>
        </button>
      </div>
    );
  }
);

export default PasswordInput;
